// Утилиты для оптимизации изображений

// Предзагрузка критических изображений
export const preloadCriticalImages = () => {
    const criticalImages = [
        '/background.svg',
        '/logo-mein.jpg',
        '/favicon.svg'
    ];

    criticalImages.forEach(src => {
        const img = new Image();
        img.src = src;
    });
};

// Ленивая загрузка изображений
export const lazyLoadImages = () => {
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });

        document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
        });
    }
};

// Оптимизация фоновых изображений
export const optimizeBackgroundImages = () => {
    const elements = document.querySelectorAll('[data-bg]');

    elements.forEach(element => {
        const bgImage = element.dataset.bg;
        if (bgImage) {
            const img = new Image();
            img.onload = () => {
                element.style.backgroundImage = `url(${bgImage})`;
                element.style.opacity = '1';
            };
            img.src = bgImage;
            element.style.opacity = '0.8';
            element.style.transition = 'opacity 0.3s ease';
        }
    });
};

// Инициализация всех оптимизаций
export const initImageOptimizations = () => {
    preloadCriticalImages();
    lazyLoadImages();
    optimizeBackgroundImages();
};
